import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'banner',
  label: 'Banner',
  description: 'Promotional strip for sales, announcements, or features.',
  supportedPages: ['home', 'shop', 'category', 'cart', 'checkout', 'order-success'],
  variants: [{ id: 'v1', label: 'V1 (Standard)' }],
  commonFields: [
    { key: 'title', label: 'Banner Title', type: 'string' },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'ctaText', label: 'Button Text', type: 'string' },
    { key: 'ctaLink', label: 'Button Link', type: 'string' },
    { key: 'backgroundImage', label: 'Background Image', type: 'image' },
  ],
}
